import "../order-tabs/order-tabs.scss";
import "./no-orders-based-on-filters.scss";

import classNames from "classnames";
import { observer } from "mobx-react-lite";

import { ReactComponent as NoResults } from "@client/components/reusable/SvgIcons/library/no_results.svg";
import { useRootContext } from "@client/context/RootContext";
import { LABELS } from "@client/utils/labels";

import { OrderTabSort } from "../order-tabs/order-tab-sort";
import { OrderTabsLoadingOverlay } from "../order-tabs/order-tabs-loading-overlay";
import SvgIcon from "../reusable/SvgIcons";

interface NoOrdersBasedOnFiltersProps {
	subtitle: string;
	buttonText?: string;
	isActiveOrders?: boolean;
}

export const NoOrdersBasedOnFilters = observer(
	(props: NoOrdersBasedOnFiltersProps) => {
		const {
			vendorStore: { vendorDetails, pullingDataInProgress },
			layoutStore: {
				sort,
				sort_search,
				setSort,
				setSearchTerm,
				searchInput_blur,
			},
		} = useRootContext();

		function onShowAllListClick() {
			setSearchTerm("");
			searchInput_blur();
		}

		return (
			<>
				{props.isActiveOrders && (
					<div className="tabs-wrapper no-results">
						<div className="tab-container new">
							<div className="tab-selector">
								<span
									className={classNames("tab-name", {
										fading: pullingDataInProgress,
									})}
								>
									Waiting for acceptance
								</span>
								<OrderTabSort
									pullingDataInProgress={pullingDataInProgress}
									sort={sort_search}
									setSort={setSort}
									columnIndex={0}
								/>
							</div>
						</div>

						<div className="tab-container picking">
							<div className="tab-selector">
								<span className="tab-name">
									{vendorDetails?.delivery_dates_enabled
										? LABELS.column_pickingAndScheduledDate
										: LABELS.column_picking}
								</span>
								<OrderTabSort
									pullingDataInProgress={pullingDataInProgress}
									sort={sort_search}
									setSort={setSort}
									columnIndex={1}
								/>
							</div>
						</div>
						<div className="tab-container ready">
							<div className="tab-selector">
								<span className="tab-name">
									{vendorDetails?.delivery_dates_enabled
										? LABELS.column_readyAndActualDate
										: LABELS.column_ready}
								</span>
							</div>
						</div>
					</div>
				)}
				<div className="no-orders-based-on-filters">
					<SvgIcon component={NoResults} width="112" height="88" />
					<div className="no-results-title">No Results</div>
					<div className="no-results-subtitle">{props.subtitle}</div>
					{props.buttonText && (
						<button className="show-all-list-btn" onClick={onShowAllListClick}>
							{props.buttonText}
						</button>
					)}

					{pullingDataInProgress && (
						<OrderTabsLoadingOverlay customHeight={300} />
					)}
				</div>
			</>
		);
	}
);
